import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LoadingStates } from 'shared/constants/loadingStates';
import { clearPlantItemRenewalForm } from 'plantItemNew/redux/slices/formSlice';
import {
  PLANT_ITEM_RENEWAL_API_BASE_URL,
  PlantItemRenewalConstants,
} from 'plantItemRenewal/constants/plantItemRenewalConstants';
import axios from 'axios';

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const itemRenewalFeesSlice = createSlice({
  name: 'plantItemRenewalFees',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlantItemRenewalFees.pending, (state, action) => {
        state.status = LoadingStates.Loading;
        state.error = null;
      })
      .addCase(getPlantItemRenewalFees.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.error = action.error.message;
      })
      .addCase(getPlantItemRenewalFees.fulfilled, (state, action) => {
        state.status = LoadingStates.Succeeded;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(clearPlantItemRenewalForm, () => {
        return initialState;
      });
  },
});

const apiUrl = `${PLANT_ITEM_RENEWAL_API_BASE_URL}/fees`;

export const getPlantItemRenewalFees = createAsyncThunk('plantItemRenewalFees/getFees', async (arg, { getState }) => {
  const { renewalItems, application } = getState();

  const selectedItems = renewalItems.items.filter((x) => x.isSelected);
  const payload = {
    applicationId: application.applicationId || 1,
    applicationNo: application.applicationNo || 'temp',
    licenceType: PlantItemRenewalConstants.licenceType,
    applicantType: PlantItemRenewalConstants.applicantType,
    durationRequested: PlantItemRenewalConstants.licenceDuration,
    itemCount: selectedItems.length,
    plantTransactionType: PlantItemRenewalConstants.transactionType,
  };

  const response = await axios.post(apiUrl, payload, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return response.data.response[0];
});

export const plantItemRenewalFeesReducer = itemRenewalFeesSlice.reducer;
